// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";
import { getEnv } from "@/lib/env";
import { customAuthStorage } from "@/lib/authStorage";

const { supabaseUrl, supabasePublishableKey } = getEnv();

// Warn if Supabase config is missing (but don't crash immediately, let createClient fail or work in limited mode)
if (!supabaseUrl || !supabasePublishableKey) {
  console.warn(
    "Supabase configuration missing (VITE_SUPABASE_URL/PROJECT_ID or VITE_SUPABASE_PUBLISHABLE_KEY). Auth features will not work."
  );
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  supabaseUrl || "https://missing-supabase-url.com",
  supabasePublishableKey || "missing-key",
  {
    auth: {
      storage: customAuthStorage,
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: "pkce",
    },
  },
);
